import axios from 'axios'
import axiosRetry from 'axios-retry'
import xhrAdapters from 'axios/lib/adapters/xhr.js'
import { version as appVersion } from '../../package.json'
import qs from 'qs'

// const appName = import.meta.env.VITE_APP_NAME

const request = axios.create({
  timeout: 1000 * 10,
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  ...(import.meta.env.SSR
    ? {}
    : {
        adapter: (config) => {
          return new Promise((resolve, reject) => {
            try {
              const url = config.url.includes('/api') ? config.url : `/api${config.url}`
              const query = qs.stringify(config?.params || {})
              const fullUrl = `${url}${query ? `?${query}` : ''}`
              if (
                typeof window !== 'undefined' &&
                window.__INITIAL_DATA__ &&
                window.__INITIAL_DATA__[fullUrl]
              ) {
                const initialData = window.__INITIAL_DATA__[fullUrl]
                delete window.__INITIAL_DATA__[fullUrl]
                resolve({
                  data: initialData,
                  status: 200,
                  statusText: 'OK',
                  headers: {},
                  config: config,
                  request: config
                })
              } else {
                xhrAdapters(config).then(resolve).catch(reject)
              }
            } catch (error) {
              xhrAdapters(config).then(resolve).catch(reject)
            }
          })
        }
      })
})

// 判断一段时间内的接口是否结束
// let numberOfAjaxCAllPending = 0
// const isAjaxCAllPendingEnd = () => {
//   setTimeout(() => {
//     numberOfAjaxCAllPending--
//     if (numberOfAjaxCAllPending === 0 && !document.querySelector(`[name="${appName}"]`)) {
//       const superUpdatesMeta = document.createElement('meta')
//       superUpdatesMeta.name = appName
//       superUpdatesMeta.content = 'true'
//       document.querySelector('head').appendChild(superUpdatesMeta)
//       document.getElementById('tvb-loading').style.display = 'none'
//       document.getElementById('tvb').style.opacity = '1'
//     }
//   }, 500)
// }

// 添加請求攔截器
request.interceptors.request.use(
  (config) => {
    //numberOfAjaxCAllPending++
    if (import.meta.env.SSR) {
      config.headers['X-App-Client'] =
        `tvb-web/zh-HK/${appVersion}/12345678-1234-5678-1234-123456789abc`

      if (globalThis?.ssrHeaders) {
        config.headers['X-Ssr-Header'] = globalThis.ssrHeaders
      }

      if (globalThis?.renderId) {
        config.headers['X-Ssr-Render-Id'] = globalThis.renderId
      }
    } else {
      if (localStorage.getItem('uuid')) {
        config.headers['X-App-Client'] =
          `tvb-web/zh-HK/${appVersion}/${localStorage.getItem('uuid')}`
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 添加響應攔截器
request.interceptors.response.use(
  (response) => {
    //isAjaxCAllPendingEnd()
    return Promise.resolve(response?.data || {})
  },
  (error) => {
    //isAjaxCAllPendingEnd()
    return Promise.reject(error)
  }
)

// 重试处理
if (!import.meta.env.SSR) {
  axiosRetry(request, {
    retries: 3,
    shouldResetTimeout: true,
    retryCondition: (error) => {
      return (
        axiosRetry.isNetworkOrIdempotentRequestError(error) || error?.message?.includes('timeout')
      )
    }
  })
}

export default request
